import { fmtEur, fmtNum } from "@/lib/format";

export type ValueFormat = "number" | "eur" | "percent";

export interface ValueFormatOptions {
  format?: ValueFormat;
  digits?: number;
  unit?: string;
  locale?: string;
}

export function formatModuleValue(
  value: number | string,
  { format = "number", digits, unit, locale }: ValueFormatOptions = {},
): string {
  if (typeof value === "string") return value;
  if (!Number.isFinite(value)) return "";
  let out: string;
  if (format === "eur") out = fmtEur(value, locale);
  else if (format === "percent")
    out = `${fmtNum(value, digits ?? (Math.abs(value) < 10 && value % 1 !== 0 ? 1 : 0), locale)} %`;
  else out = fmtNum(value, digits ?? 0, locale);
  return unit ? `${out} ${unit}` : out;
}

export function formatShare(fraction: number, digits = 0, locale?: string): string {
  return `${fmtNum(fraction * 100, digits, locale)} %`;
}

export function chartSlot(index: number): string {
  return `var(--chart-${(((index % 5) + 5) % 5) + 1})`;
}
